import styled from 'styled-components';

export const ButtonContainer = styled.button`
  padding: 20px;
  border: 10px solid white; 
  background-color:#0A0A0A;
  color: #FFFFFF;
  font-size: 24px;
  font-weight: 700;
  border-radius: 8px !important;
  flex: 1;

  &:hover {
    opacity: 0.7;
  }
`